export default __webpack_public_path__ + "static/NotoSans-Regular.subset-f6b845233a701f3a4d4208e6496aee93.otf";